import { getChildWidgetStyle, handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import { Box } from '@mui/material';
import React from 'react';
const type = 'badges.customLayout';
const CustomLayoutWidget = (props) => {
    return (React.createElement(Box, { className: 'badges-custom-layout-widget', sx: props.config.rootSx }, props.childProps &&
        props.childProps.map((childProp, index) => {
            var _a;
            return (React.createElement(Box, { key: childProp.id, sx: (_a = props.config.childrenSx) === null || _a === void 0 ? void 0 : _a[index], style: getChildWidgetStyle(childProp) },
                React.createElement(WidgetComponent, Object.assign({}, childProp))));
        })));
};
export const customLayoutWidget = {
    type,
    createWidget: () => {
        return {
            type,
            children: [],
        };
    },
    update: (props) => {
        props.update();
        return handleWidgetUpdate(props);
    },
    childConfigs: (config) => config.children,
    component: CustomLayoutWidget,
};
